module.exports = __webpack_public_path__ + "static/media/assistant@2x.41a23f77.png";